import styled from '@emotion/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export const NewCourseBox = styled.div`
  background: rgba(245, 247, 248, 0.6);
`;

export const ArrowBack = styled(ArrowBackIcon)`
  color: rgba(255, 255, 255, 1);
`;

export const Button = styled.button`
  width: 80px;
  height: 80px;
  margin-right: 24px;
  background: rgba(55, 71, 79, 1);
  cursor: pointer;
`;
export const Header = styled.header`
  display: flex;
  align-items: center;
  width: 1366px;
  height: 80px;
  background: #ffffff;
`;
export const Subtitle = styled.h2`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 1.2;
  color: #37474f;
`;
export const Maim = styled.main`
  background: rgba(245, 247, 248, 0.6);
`;
export const BoxMaim = styled.div`
  width: 1094px;
  display: flex;
  flex-direction: column;
  margin: 0px auto;
`;
